export const NEEDED_ACTIONS_KEY = "needed-actions";

export const APPOINTMENT_QUERY_KEYS = {
  scholarAppointments: () => ["scholar-appointments"],
  teacherAppointments: () => ["teacher-appointments"],
};

export const BOOKING_QUERY_KEYS = {
  userBookings: () => ["user-bookings"],
  userBooking: (bookingId?: string) => ["user-booking", bookingId],
  teacherBookings: () => ["teacher-bookings"],
  changeRequests: (bookingId?: string, status?: string) => [
    "booking-change-requests",
    bookingId,
    status,
  ],
};

// Base keys: spread with ids to build detail keys; pass as-is to invalidateKeys
// to invalidate the whole family via prefix match.
export const BOOKING_INVALIDATION_KEYS = {
  userBooking: ["user-booking"],
  teacherBookingsDashboard: ["teacher-bookings-dashboard"],
  cancelInformation: ["bookingCancelInformation"],
  changeRequests: ["booking-change-requests"],
  userPendingChangeRequests: ["user-pending-change-requests"],
};

export const SUBSCRIPTION_QUERY_KEYS = {
  userSubscriptions: ["user-subscriptions"],
  userSubscription: ["user-subscription"],
  teacherSubscriptions: ["teacher-subscriptions"],
  teacherSubscriptionsById: ["teacher-subscriptions-by-id"],
  teacherSubscriptionsDashboard: ["teacher-subscriptions-dashboard"],
};

export const CHAT_QUERY_KEYS = {
  chats: ["chats"],
  messages: ["messages"],
};

export const LOCATION_QUERY_KEYS = {
  locations: ["locations"],
  location: ["location"],
  teacherLocations: ["teacher-locations"],
};

export const MEDIA_QUERY_KEYS = {
  media: ["media"],
};

export const USER_QUERY_KEYS = {
  userData: ["userData"],
};

export const SCHEDULE_QUERY_KEYS = {
  schedule: ["schedule"],
  oneTimeSlots: ["one-time-slots"],
  blocker: ["blocker"],
};

export const TEACHER_QUERY_KEYS = {
  teacherFeedback: ["teacher-feedback"],
  allTeacherFeedback: ["all-teacher-feedback"],
  teacherLessonPrices: ["teacher-lesson-prices"],
};
